module.exports = __webpack_public_path__ + "static/media/chevron-square-right.05d190c6.svg";